<a href="/">
    <span class="logo-block">
      <img class="img-logo" src='../../assets/next-me-logo.svg' alt="nextme logo">
      NextMe
    </span>
</a>
<div class="auth">
    <router-outlet></router-outlet>
</div>